namespace liveChatModule {

    class LiveChat {

        public showThanks: boolean = false;

        constructor (
            private liveChatService: LiveChatService,
            private $timeout: ng.ITimeoutService
        )
        {
            this.showThanks = false;
        }

        public startChat = () => {
            if(TRPCONFIG.Domain.LiveChat.Ready) {
                this.liveChatService.startChat(TRPCONFIG.Domain.LiveChat.ButtonCode);
            }
        }

        public rejectChat = () => {
            if(TRPCONFIG.Domain.LiveChat.Ready){
                this.liveChatService.rejectChat(TRPCONFIG.Domain.LiveChat.ButtonCode);
            }
        }

        public closeThanks = () => {
            this.$timeout(() => {
                this.showThanks = false;
            }, 1000);
        }
    }

    angular
        .module('liveChatModule')
        .directive('liveChat', (): ng.IDirective => {
            return {
                scope: {},
                replace: true,
                bindToController: {},
                controller: LiveChat,
                controllerAs: 'lc',
                templateUrl: `partials/home/liveChat`
            };
        });
}
